module.exports = __webpack_public_path__ + "static/media/mvp.4257d1b7.png";